// src/pages/admin/AddUser.js
import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import { Box } from "../../../components/elements";
import { Button as MuiButton } from '@mui/material';
import PageLayout from "../../../layouts/PageLayout";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export default function AddUser() {
  const navigate = useNavigate();

  const [user, setUser] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    phone: "",
    role: "1",                      // 1 → User
    access_level: ["ITEMS_MODULE"], // default for User
  });

  const addUser = async () => {
    const { name, email, password, role } = user;
    if (!name || !email || !password || !role) {
      alert("Please fill in Name, Email, Password & Role.");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}admin/create-user`,
        user,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      alert("User created successfully!");
      navigate("/users-list");
    } catch (error) {
      console.error("Error adding user:", error);
      alert(
        error.response?.data?.message ||
          "Error creating user. Please try again."
      );
    }
  };

  const handleRoleChange = (e) => {
    const newRole = e.target.value;
    setUser({
      ...user,
      role: newRole,
      access_level:
        newRole === "1"
          ? ["ITEMS_MODULE"]
          : ["ORDERS_MODULE"], // default for Plant Foreman
    });
  };

  return (
    <PageLayout>
      <Grid container spacing={2}>
        {/* Breadcrumb & Back Link */}
        <Grid size={{ xs: 12 }} className="d-flex justify-content-between">
          <Breadcrumb title="Add User" />
          <Link to="/users-list">
            <MuiButton variant="contained" color="primary">Users List</MuiButton>
          </Link>
        </Grid>

        {/* User Details Form */}
        <Grid size={{ xs: 12 }} className="mt-3">
          <Box className="mc-card">
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, xl: 3 }} className="mb-3">
                <CardHeader title="Name" />
                <TextField
                  fullWidth
                  placeholder="Enter full name"
                  value={user.name}
                  onChange={(e) =>
                    setUser({ ...user, name: e.target.value })
                  }
                />
              </Grid>

              <Grid xl={3} className="mb-3">
                <CardHeader title="Username" />
                <TextField
                  fullWidth
                  placeholder="Enter username"
                  value={user.username}
                  onChange={(e) =>
                    setUser({ ...user, username: e.target.value })
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, xl: 3 }} className="mb-3">
                <CardHeader title="Email" />
                <TextField
                  type="email"
                  fullWidth
                  placeholder="Enter email address"
                  value={user.email}
                  onChange={(e) =>
                    setUser({ ...user, email: e.target.value })
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, xl: 3 }} className="mb-3">
                <CardHeader title="Password" />
                <TextField
                  type="password"
                  fullWidth
                  placeholder="Enter password"
                  value={user.password}
                  onChange={(e) =>
                    setUser({ ...user, password: e.target.value })
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, xl: 3 }} className="mb-3">
                <CardHeader title="Phone" />
                <TextField
                  type="tel"
                  fullWidth
                  placeholder="Enter phone number"
                  value={user.phone}
                  onChange={(e) =>
                    setUser({ ...user, phone: e.target.value })
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, xl: 3 }} className="mb-3">
                <CardHeader title="Role" />
                <TextField
                  select
                  fullWidth
                  value={user.role}
                  onChange={handleRoleChange}
                >
                  <MenuItem value="1">User</MenuItem>
                  <MenuItem value="2">Plant Foreman</MenuItem>
                </TextField>
              </Grid>

              <Grid size={{ xs: 12, xl: 3 }} className="mb-3">
                <CardHeader title="Access Level" />
                <TextField
                  select
                  fullWidth
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) => selected.join(", "),
                  }}
                  value={user.access_level}
                  onChange={(e) =>
                    setUser({ ...user, access_level: e.target.value })
                  }
                >
                  <MenuItem value="ITEMS_MODULE">
                    Items Module
                  </MenuItem>
                  <MenuItem value="ORDERS_MODULE">
                    Orders Module
                  </MenuItem>
                  <MenuItem value="JOBS_MODULE">
                    Jobs Module
                  </MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Add User Button */}
        <Grid size={{ xs: 12 }} className="mt-3 d-flex justify-content-end">
          <MuiButton variant="contained" color="primary" onClick={addUser}>
            Add User
          </MuiButton>
        </Grid>
      </Grid>
    </PageLayout>
  );
}
